import { classed } from "@/lib/classed";

/**
 * HStack — horizontal flex row with centered items and consistent gap.
 * Use for icon+text pairs, metadata rows, inline groups.
 * Supports `as` prop: `<HStack as="nav">` renders a `<nav>`.
 */
export const HStack = classed("div", {
  base: "flex items-center",
  variants: {
    gap: {
      none: "",
      xs: "gap-1",
      sm: "gap-1.5",
      md: "gap-2",
      lg: "gap-3",
      xl: "gap-4",
    },
    align: {
      start: "items-start",
      end: "items-end",
      stretch: "items-stretch",
      baseline: "items-baseline",
    },
    justify: {
      start: "justify-start",
      center: "justify-center",
      end: "justify-end",
      between: "justify-between",
    },
    wrap: {
      true: "flex-wrap",
    },
    shrink: {
      true: "flex-shrink-0",
    },
    truncate: {
      true: "min-w-0",
    },
    fill: {
      true: "flex-1",
    },
    inline: {
      true: "inline-flex",
    },
  },
  defaultVariants: {
    gap: "md",
  },
});
